import * as actionTypes from './actionTypes';

export const setStackFlight = (flightSchedule, fareDetails, date, supplierCode, flightId, flightType, xmlKey) => {
    return {
        type: actionTypes.SET_STACK_FLIGHT,
        flightSchedule: flightSchedule,
        fareDetails: fareDetails,
        flightId: flightId,
        date: date,
        supplierCode: supplierCode,
        flightType: flightType,
        xmlKey: xmlKey
    }
}

export const resetStackFlight = () => {
    return {
        type: actionTypes.RESET_STACK_FLIGHT
    }
}


// WEBPACK FOOTER //
// ./src/store/actions/stackDepartureTuple.js